import { memo } from "react";

import { Image } from "@components/Image";
import { Text } from "@components/Text";
import { type BrandValueProp } from "@root/tablescape/state";
import { formatFullyQualifiedUrl } from "@root/tablescape/utilities";
import { tw } from "classnames";

const styles = {
  base: tw("flex", "flex-col", "items-center", "gap-y-4", "pt-4"),
  text: tw("pb-2", "text-primary"),
};

const BrandValuePropItemBase = ({
  valueProp,
}: {
  valueProp: BrandValueProp;
}) => {
  return (
    <div className={styles.base}>
      <Image
        alt={valueProp.image.altText}
        height={33}
        src={formatFullyQualifiedUrl(valueProp.image.url)}
        width={48}
      />
      <Text as="caption" className={tw(styles.text)}>
        {valueProp.text}
      </Text>
    </div>
  );
};

export const BrandValuePropItem = memo(BrandValuePropItemBase);
